module.exports = {"Operate3":{"daobanList":[{"title":"1:请问需要变更大型户外广告的什么内容？","values":[{"name":"法人变更","xuanzhong":1,"cailiaoList":[{"name":"1、广州市户外广告设置证","state":"必要"},{"name":"2、变更情况书面说明","state":"必要"}]},{"name":"企业名称变更","xuanzhong":1,"cailiaoList":[{"name":"1、广州市户外广告设置证","state":"必要"},{"name":"2、变更情况书面说明","state":"必要"}]},{"name":"公司地址变更","xuanzhong":1,"cailiaoList":[{"name":"1、广州市户外广告设置证","state":"必要"},{"name":"2、变更情况书面说明","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-3.json
// module id = 1284
// module chunks = 0